import { useState } from "react";
import Description from "../Inputs/Description";
import ModalFooterSaveCancel from "./ModalFooterSaveCancel";
import ModalHeader from "./ModalHeader";

export interface EditBucketNodeModel {
	bucketNodeId?: number,
	bucketTypeKey: string,
	parentBucketNodeId?: number,
	displayName: string,
	isInactive: boolean,
	isViewTransactions: boolean
}

const EditBucketNode = (props: any) => {
	let [item, setItem] = useState(props.Item as EditBucketNodeModel);

	return (<>
		<ModalHeader
			Title={`${item.bucketNodeId && item.bucketNodeId > 0 ? 'Edit' : 'Add'} ${props.NodeLabel}`}
			CanDelete={props.OnDelete !== undefined}
			Close={props.Close}
			Delete={() => props.OnDelete(item)} />
		<div className="modal-body mt-5">
			<Description Label="Description" Value={item.displayName} OnChange={(val: any) => UpdateDescription(val.target.value)} Size={12} />
			{props.UsageMessage && (
				<div className="text-app mt-3">
					<small>{props.UsageMessage}{props.OnDelete === undefined ? " — cannot delete while in use." : ""}</small>
				</div>
			)}
		</div>
		<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={() => props.OnSave(item)} Close={props.Close} />
	</>);

	function ShouldShowSave() {
		return item.displayName != null && item.displayName.trim().length > 0;
	}

	function UpdateDescription(newValue: string) {
		item = ({ ...item, displayName: newValue });
		setItem(item);
	}
}

export default EditBucketNode;
